export var FONT_SANS_ORI = 'SansOri, SansOriFallback, sans-serif';
//# sourceMappingURL=constants.js.map